import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
// import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOption } from '@angular/material/core';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { RoleGroupApiService } from '../CommonController/role-group-service';
import { RoleMenuApiService } from '../CommonController/roleMenu-api-service';
import { MenuItem } from '../shared/variables/MenuItem';
@Component({
  selector: 'app-user-role-page',
  templateUrl: './user-role-page.component.html',
  styleUrls: ['./user-role-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSelect,
    MatOption,
    MatCheckbox,
    CommonModule,
  ],
})
export class UserRolePageComponent implements OnInit {
  addRoleForm!: FormGroup;
  roleSearchForm!: FormGroup;
  pageNo = 1;
  pageSize = 10;
  totalItems = 0;
  listOfRole = [];
  submitButton = true;
  updateButton = false;
  rid = 0;
  searchText = '';
  permissionList = [];
  roleTypeList = [
    { name: 'Super Administrator', value: 'SA' },
    { name: 'Administrator', value: 'AD' },
    { name: 'Manager', value: 'MN' },
    { name: 'Team Lead', value: 'TL' },
    { name: 'User', value: 'US' },
    { name: 'External', value: 'EX' },
  ];

  roleGroupList = [];
  allPages: MenuItem[] = [];
  permission: string[] = [];
  view = false;
  isAddRole = false;
  viewRoleGroup = false;
  roleType = '';

  userRoleView = false;
  userRoleDelete = false;
  userRoleCreate = false;
  userRoleUpdate = false;
  userPermissions = [];
  userType = '';

  constructor(
    private formBuilder: FormBuilder,
    public commonApiService: CommonApiService,
    public roleMenuApiService: RoleMenuApiService,
    public roleGroupApiService: RoleGroupApiService,
    private spinner: NgxSpinnerService,
    public router: Router // private sessionstorge: SessionStorageService,
  ) {}

  ngOnInit() {
    this.rid = 0;
    this.checkPermission();
    this.setUserRoleForm();
    if (this.userRoleView) {
      this.fetchRoleList();
      this.fetchRoleGroupList();
      this.menuPermissionList();
    }
  }

  checkPermission() {
    this.roleType = sessionStorage.getItem('roleType') || '';
    if (this.roleType === 'Super Administrator') {
      this.userRoleView = true;
      this.userRoleCreate = true;
      this.userRoleUpdate = true;
      this.userRoleDelete = true;
    } else {
      this.navigateBack();
    }
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions') || '[]'
    );
    this.userPermissions.forEach((element: any) => {
      if (element.pageName === 'Role Management' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Role Management' && element.view === true) {
        this.userRoleView = true;
      }
      if (element.pageName === 'Role Management' && element.create === true) {
        this.userRoleCreate = true;
      }
      if (element.pageName === 'Role Management' && element.update === true) {
        this.userRoleUpdate = true;
      }
      if (element.pageName === 'Role Management' && element.delete === true) {
        this.userRoleDelete = true;
      }
    });
  }

  setUserRoleForm() {
    this.addRoleForm = this.formBuilder.group({
      userRole: [
        '',
        (Validators.required, Validators.pattern('^[A-Za-z/ ]+$')),
      ],
      roleType: ['', Validators.required],
      roleGroup: [''],
      createdAt: new Date(),
    });
    this.roleSearchForm = this.formBuilder.group({
      roleNameSearch: new FormControl(''),
    });
  }

  saveRole() {
    if (this.addRoleForm.invalid) {
      this.addRoleForm.get('userRole')?.markAsTouched();
      this.addRoleForm.get('roleType')?.markAsTouched();
      return;
    }

    if (
      this.addRoleForm.get('roleType')?.value !== 'SA' &&
      this.addRoleForm.get('roleType')?.value !== 'AD'
    ) {
      if (!this.addRoleForm.get('roleGroup')?.value) {
        // Checks for null, undefined, or empty string
        this.addRoleForm.get('roleGroup')?.markAsTouched();
        this.addRoleForm.get('roleGroup')?.updateValueAndValidity();
        this.commonApiService.openSnackbar('Role Group is mandatory'); // Update validity to trigger error
        return;
      }
    }

    this.spinner.show();
    const payload = this.addRoleForm.value;
    payload.roleId = this.rid;
    payload.userPermission = this.allPages;
    this.roleMenuApiService.addRole(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
          this.isAddRole = false;
          this.ngOnInit();
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        if (ERROR.error.message === 'Validation Error') {
          for (const error of ERROR.error.errors) {
            this.commonApiService.openSnackbar(error);
          }
        } else {
          this.commonApiService.openSnackbar(ERROR.error.message);
        }
      },
    });
  }

  fetchRoleList() {
    this.spinner.show();
    this.listOfRole = [];
    this.roleMenuApiService
      .getRole(this.pageNo - 1, this.pageSize, this.searchText, '')
      .subscribe({
        next: (res) => {
          this.listOfRole = res.data;
          this.totalItems = res.totalItems;
          this.spinner.hide();
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.commonApiService.openSnackbar(ERROR.error.message);
        },
      });
  }

  fetchRoleGroupList() {
    this.roleGroupApiService.getAllRoleGroup(0, 1000, '').subscribe({
      next: (res) => {
        this.roleGroupList = res.data;
      },
      error: (ERROR: HttpErrorResponse) => {
        this.listOfRole = [];
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  onPageChange(event: number): void {
    this.pageNo = event;
    this.fetchRoleList();
  }

  onSizeChange(pageSize: number): void {
    this.pageSize = pageSize; // Update the pageSize
    this.pageNo = 1; // Reset to the first currentPage
    sessionStorage.setItem('pageSize', this.pageSize.toString());
    this.fetchRoleList();
  }

  fetchDataById(id: number) {
    this.roleMenuApiService.getRoleById(id).subscribe({
      next: (res) => {
        if (res.status) {
          const data = res.data;
          this.updateButton = true;
          this.submitButton = false;

          const roleTypeValue =
            this.roleTypeList.find((role) => role.name === data.roleType)
              ?.value || data.roleType;
          if (roleTypeValue != 'AD' && roleTypeValue != 'SA') {
            this.viewRoleGroup = true;
          } else {
            this.viewRoleGroup = false;
          }
          this.addRoleForm = this.formBuilder.group({
            userRole: new FormControl(data.userRole, [
              Validators.required,
              Validators.pattern('^[A-Za-z/ ]+$'),
            ]),

            roleType: new FormControl(roleTypeValue, [Validators.required]),
            roleGroup: new FormControl(data.groupId),
            updatedAt: new Date(),
          });
          this.rid = data.roleId;
          this.addRole('update', data.rolePermissionResDtos);
        } else {
          this.commonApiService.openSnackbar('Operation Failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  onSearchRolename(event: string) {
    this.searchText = event;
    this.pageNo = 1;
    this.fetchRoleList();
  }

  updateRole() {
    if (this.addRoleForm.invalid) {
      this.addRoleForm.get('userRole')?.markAsTouched();
      this.addRoleForm.get('roleType')?.markAsTouched();
      return;
    }

    this.spinner.show();
    const payload = this.addRoleForm.value;
    payload.roleId = this.rid;
    payload.userPermission = this.allPages;
    this.roleMenuApiService.updateRole(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.updateButton = false;
          this.submitButton = true;
          this.commonApiService.openSnackbar(res.message);
          this.spinner.hide();
          this.isAddRole = false;
          this.ngOnInit();
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar('Operation Failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        // alert(ERROR.error.message);
        this.spinner.hide();
        if (ERROR.error.message === 'Validation Error') {
          for (const error of ERROR.error.errors) {
            this.commonApiService.openSnackbar(error);
          }
        } else {
          this.commonApiService.openSnackbar(ERROR.error.message);
        }
      },
    });
  }

  deleteRole(userRoleId: number) {
    if (confirm('Are you sure? Do you want to delete')) {
      this.spinner.show();
      this.roleMenuApiService.deleteRole(userRoleId).subscribe({
        next: (res) => {
          if (res.status) {
            this.commonApiService.openSnackbar(res.message);
            this.spinner.hide();
            this.ngOnInit();
          } else {
            this.spinner.hide();
            this.commonApiService.openSnackbar('Operation Failed');
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          // alert(ERROR.error.message);
          this.spinner.hide();
          this.commonApiService.openSnackbar(ERROR.error.message);
        },
      });
    }
  }

  changePage() {
    this.isAddRole = false;
    this.menuPermissionList();
    this.fetchRoleList();
    this.submitButton = true;
    this.updateButton = false;
  }

  addRole(operationType: any, data: any) {
    if (operationType === 'add') {
      this.rid = 0;
      this.addRoleForm.reset();
    } else if (operationType === 'update') {
      if (data.length > 0) {
        for (const page of this.allPages as MenuItem[]) {
          for (const item of data) {
            if (page.pageName === item.pageName) {
              page.view = item.view;
              page.create = item.create;
              page.update = item.update;
              page.delete = item.delete;
              break;
            }
          }
        }
      }
    }
    this.updateChildMenuDisableStatus(this.allPages);
    this.isAddRole = true;
  }

  updateChildMenuDisableStatus(menuList: MenuItem[]) {
    const menuMap = new Map<number, MenuItem>();
    menuList.forEach((menu) => menuMap.set(menu.id, menu));

    menuList.forEach((menu) => {
      if (menu.parentMenuId != null) {
        const parent = menuMap.get(menu.parentMenuId);
        const parentView = parent?.view ?? false;
        menu.isDisabled = !parentView;
        if (!parentView) {
          menu.view = false;
          menu.create = false;
          menu.update = false;
          menu.delete = false;
        }
      } else {
        // Parent menus are always enabled
        menu.isDisabled = false;
      }
    });
    this.allPages = menuList;
  }

  onSelectAllPagesChange(e: any) {
    if (e.checked === true) {
      for (const page of this.allPages as MenuItem[]) {
        page.selectAll = true;
        page.view = true;
        page.create = true;
        page.update = true;
        page.delete = true;
      }
    } else if (e.checked === false) {
      for (const page of this.allPages as MenuItem[]) {
        page.selectAll = false;
        page.view = false;
        page.create = false;
        page.update = false;
        page.delete = false;
      }
    }
  }

  onSelectViewPagesChange(e: any) {
    if (e.checked === true) {
      for (const page of this.allPages as MenuItem[]) {
        page.view = true;
      }
    } else if (e.checked === false) {
      for (const page of this.allPages as MenuItem[]) {
        page.selectAll = false;
        page.view = false;
      }
    }
  }

  onSelectCreatePagesChange(e: any) {
    if (e.checked === true) {
      for (const page of this.allPages as MenuItem[]) {
        page.create = true;
      }
    }

    if (e.checked === false) {
      for (const page of this.allPages as MenuItem[]) {
        page.selectAll = false;
        page.create = false;
      }
    }
  }

  onSelectUpdatePagesChange(e: any) {
    if (e.checked === true) {
      for (const page of this.allPages as MenuItem[]) {
        page.update = true;
      }
    } else if (e.checked === false) {
      for (const page of this.allPages as MenuItem[]) {
        page.selectAll = false;
        page.update = false;
      }
    }
  }

  onSelectDeletePagesChange(e: any) {
    if (e.checked === true) {
      for (const page of this.allPages as MenuItem[]) {
        page.delete = true;
      }
    }

    if (e.checked === false) {
      for (const page of this.allPages as MenuItem[]) {
        page.selectAll = false;
        page.delete = false;
      }
    }
  }

  onCheckboxDeleteChange(e: any) {
    if (e.target.checked === true) {
      this.permission.push(e.target.value);
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.delete = true;
        }
      }
    }

    if (e.target.checked === false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.delete = false;
        }
      }
    }
  }

  onCheckboxUpdateChange(e: any) {
    if (e.target.checked === true) {
      this.permission.push(e.target.value);
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.update = true;
        }
      }
    }

    if (e.target.checked === false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.update = false;
        }
      }
    }
  }

  onCheckboxCreateChange(e: any) {
    if (e.target.checked === true) {
      this.permission.push(e.target.value);
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.create = true;
        }
      }
    }

    if (e.target.checked === false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.create = false;
        }
      }
    }
  }

  onCheckboxViewChange(e: any) {
    if (e.target.checked === true) {
      this.permission.push(e.target.value);
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.view = true;
        }
      }
    }

    if (e.target.checked === false) {
      this.permission.splice(this.permission.indexOf(e.target.value), 1);
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.view = false;
        }
      }
    }
    this.updateChildMenuDisableStatus(this.allPages);
  }

  onSelectAllChange(e: any) {
    if (e.target.checked === true) {
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.selectAll = true;
          page.view = true;
          page.create = true;
          page.update = true;
          page.delete = true;
        }
      }
    } else if (e.target.checked === false) {
      for (const page of this.allPages as MenuItem[]) {
        if (e.target.value === page.pageName) {
          page.selectAll = false;
          page.view = false;
          page.create = false;
          page.update = false;
          page.delete = false;
        }
      }
    }
    this.updateChildMenuDisableStatus(this.allPages);
  }

  menuPermissionList() {
    // this.allPages = [];
    this.spinner.show();
    this.roleMenuApiService.getAllMenus().subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.allPages = res.data;
          this.sortMenus(this.allPages);
        } else {
          this.spinner.hide();
          this.commonApiService.openSnackbar('Operation Failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        // alert(ERROR.error.message);
        this.spinner.hide();
        this.commonApiService.openSnackbar(ERROR.error.message);
      },
    });
  }

  sortMenus(menuList: MenuItem[]) {
    const grouped: Record<string, MenuItem[]> = {};

    menuList.forEach((item) => {
      const key =
        item.parentMenuId === null ? 'root' : item.parentMenuId.toString();
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    });

    // Step 2: Sort each group by sequenceId
    Object.keys(grouped).forEach((key) => {
      grouped[key].sort((a, b) => a.sequenceId - b.sequenceId);
    });

    // Step 3: Recursively build sorted list
    const sorted: MenuItem[] = [];

    const buildHierarchy = (items: MenuItem[], level = 0) => {
      for (const item of items) {
        item.level = level;
        item.isDisabled = false;
        sorted.push(item);
        const children = grouped[item.id.toString()];
        if (children) {
          buildHierarchy(children, level + 1);
        }
      }
    };

    const rootItems = grouped['root'];
    if (rootItems) {
      buildHierarchy(rootItems);
    }

    this.allPages = sorted;
  }

  navigateBack() {
    this.commonApiService.back();
  }

  onClickAddRoleRefresh() {
    this.menuPermissionList();
    if (this.rid === 0) {
      this.addRoleForm.reset();
    } else {
      this.fetchDataById(this.rid);
    }
  }

  onRoleTypeChange(event: MatSelectChange) {
    if (event.value != 'AD' && event.value != 'SA') {
      this.viewRoleGroup = true;
    } else {
      this.viewRoleGroup = false;
      this.addRoleForm.controls['roleGroup'].setValue('');
    }
  }
}
